import { TRTCVideoResolution } from "@tencentcloud/tuiroom-engine-js";
var IconButtonLayout = /* @__PURE__ */ ((IconButtonLayout2) => {
  IconButtonLayout2["VERTICAl"] = "vertical";
  IconButtonLayout2["HORIZONTAL"] = "horizontal";
  return IconButtonLayout2;
})(IconButtonLayout || {});
({
  videoResolution: TRTCVideoResolution.TRTCVideoResolution_640_360,
  videoFps: 15,
  videoBitrate: 800
});
var USERS_STATUS = /* @__PURE__ */ ((USERS_STATUS2) => {
  USERS_STATUS2[USERS_STATUS2["Entered"] = 1] = "Entered";
  USERS_STATUS2[USERS_STATUS2["ON_STAGE"] = 1] = "ON_STAGE";
  USERS_STATUS2[USERS_STATUS2["NOT_ON_STAGE"] = 2] = "NOT_ON_STAGE";
  USERS_STATUS2[USERS_STATUS2["NOT_ENTER"] = 3] = "NOT_ENTER";
  return USERS_STATUS2;
})(USERS_STATUS || {});
const PASSWORD_MAX_LENGTH_LIMIT = 6;
var TRTCBeautyStyle = /* @__PURE__ */ ((TRTCBeautyStyle2) => {
  TRTCBeautyStyle2[TRTCBeautyStyle2["TRTCBeautyStyleSmooth"] = 0] = "TRTCBeautyStyleSmooth";
  TRTCBeautyStyle2[TRTCBeautyStyle2["TRTCBeautyStyleNature"] = 1] = "TRTCBeautyStyleNature";
  return TRTCBeautyStyle2;
})(TRTCBeautyStyle || {});
export {
  IconButtonLayout,
  PASSWORD_MAX_LENGTH_LIMIT,
  TRTCBeautyStyle,
  USERS_STATUS
};
